import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { acceptFieldviewInvitationApi } from '/@/hooks/nodes';
import { _ } from '/@/locale';
import { reverse } from '/@/utils/router';

const AcceptInvitationView = () => {
    const { token } = useParams();
    const navigate = useNavigate();

    const handleAcceptInvitation = async () => {
        try {
            if (token) {
                await acceptFieldviewInvitationApi({ token });
                enqueueSnackbar(_('Invitación aceptada correctamente'), { variant: 'success' });
            }
        } catch (error) {
            enqueueSnackbar(_('Error al aceptar la invitación'), { variant: 'error' });
        }
        navigate(reverse('Home'));
    };

    useEffect(() => {
        handleAcceptInvitation();
    }, []);

    return null;
};

export default AcceptInvitationView;
